import React, {Component, Fragment} from 'react';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {Card, CardBody, CardTitle, Col, Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from "../../../../components/common/react-notifications";
import {selectStyles} from "../../../../helpers/Utils";
import Rbac from '../../../../components/Rbac';
import {withTranslation} from 'react-i18next';
import Skeleton from "react-loading-skeleton";
import Api from '../../../../services/Api';
import Select from "react-select";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gatewayList: [],
      depositGateway: null,
      withdrawGateway: null,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    await this.fetchGateways();
  };

  fetchGateways = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v1/admin-ui/gateways');
      this.setState(state => ({
        ...state,
        ...data,
      }));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  updateGateway = async (type, gatewayName) => {
    const {t} = this.props;
    try {
      await Api.invoke('PATCH', `/v1/admin-ui/${type}-gateway-setting`, {
        gatewayName,
      });
      this.fetchData();
      NotificationManager.success(t('{{type}} gateway changed to {{name}} successfully' ,{
        type: t(type),
        name: gatewayName,
      }), t('Message'));
    } catch (e) {
      console.log('error: ', e);
    }
  };

  render() {
    const {t, match} = this.props;
    const {gatewayList, depositGateway, withdrawGateway} = this.state;
    const options = gatewayList.map(item => ({label: item, value: item}));
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Gateways')}
                </CardTitle>
                <Row className='align-items-center col-8 my-3'>
                  <Col className="col-2">{t('Deposit Gateway')}</Col>
                  <Col>
                    {options ?
                      <Select
                        options={options}
                        styles={selectStyles}
                        value={options.find(item => item.value === depositGateway)}
                        onChange={async selected => {await this.updateGateway("deposit", selected.value);}}
                        isDisabled={!Rbac.hasPermission('update_deposit-gateway-setting')}
                        placeholder={t('Select Gateway')}
                        className="w-25"
                      /> :
                      <Skeleton width={60} />}
                  </Col>
                </Row>
                <Row className='align-items-center col-8 my-3'>
                  <Col className="col-2">{t('Withdraw Gateway')}</Col>
                  <Col>
                    {options ?
                      <Select
                        options={options}
                        styles={selectStyles}
                        value={options.find(item => item.value === withdrawGateway)}
                        onChange={async selected => {await this.updateGateway("withdraw", selected.value);}}
                        isDisabled={!Rbac.hasPermission('update_withdraw-gateway-setting')}
                        placeholder={t('Select Gateway')}
                        className="w-25"
                      /> :
                      <Skeleton width={60} />}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
